export default "<template>\n\n  <KButton\n    text=\"Icon Before\"\n    icon=\"add\"\n  />\n\n</template>\n";